import { useCheckAccountTraits } from '@cmg/auth';
import { Alert, AlertTitle, Typography } from '@cmg/design-system';
import React from 'react';

const CertificatesNoAccessBanner: React.FC = () => {
  const hasCertificateLibraryTrait = useCheckAccountTraits(['CERTIFICATE_LIBRARY']);

  if (hasCertificateLibraryTrait) return null;

  return (
    <Alert severity="info" data-testid="certificates-no-access-banner">
      <AlertTitle>No certificates are visible.</AlertTitle>
      <Typography variant="body2">
        Your firm does not have access to CMG Certificate Library.
      </Typography>
      <Typography variant="body2">In order to gain access, please contact CMG sales.</Typography>
    </Alert>
  );
};

export default CertificatesNoAccessBanner;
